// extracted by mini-css-extract-plugin
module.exports = {"controls":"Controls_controls__s91O4","export":"Controls_export__3atqV","error":"Controls_error__1EF4x","colorCountInput":"Controls_colorCountInput__2jHUa"};